import React, { useState, useEffect } from "react";
import {
  FormStyle,
  PageDescriptionLoginMobileStyle,
} from "../../login/components/RightSideContainer";
import { Button } from "../../../components/Button";
import { EKYC_LOGIN_TITLE } from "./constant";
import { useHistory } from "react-router-dom";
import ROUTES, { EKYC } from "../../../helpers/constants/routes";
import LoginAction from "../../../actions/ekyc/login/Login";
import OtpSentAction from "../../../actions/ekyc/login/otpSent";
import useStore from "../../../appZustand/store";
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { LOGOUT_ALL_SESSION } from "../../../helpers/constants/apiUrl";
import { MobileTextBox } from "../../../components/MobileTextBox";
import FooterMobile from "../../login/components/FooterMobile";
import CommonInput from "../../login/componentLoginScreen/CommonInput";
import {
  secureSectionContainer,
  secureItem,
  secureLogo,
  secureTextContainer,
  secureTitle,
  secureSubtitle,
  secureLogo_Shield,
  secureLogo_iso,
} from "../../../theme/commonStyles.js";
import { getDeviceType } from "../../../utils/CommonFunction.js";
import { DeviceType } from "../../../helpers/constants/constant.js";

const EkycLogin = () => {
  const { fetchMobileNo } = useStore((state) => state);
  const history = useHistory();
  const [data, setData] = useState({
    mobileNumber: "",
    isError: false,
    errorObj: {},
    isLoading: false,
    isSessionClear: false,
    mobileView: false,
  });

  useEffect(() => {
    // const mql = window.matchMedia("(max-width: 600px)");
    const mobileView =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;
    if (mobileView) {
      setData({
        mobileView: true,
      });
    }
    const data = JSON.parse(localStorage.getItem("451")) || {};
    if (Object.keys(data).length) {
      setData({
        isSessionClear: true,
        isError: true,
        errorObj: {
          ...data,
        },
      });

      localStorage.removeItem("451");
    }
  }, []);

  const onChangeAction = (e) => {
    const { name, value } = e.target;
    const cleanValue = value.replace(/\D/g, "");
    if (cleanValue.length === 11) {
      return false;
    }
    setData({ ...data, [name]: cleanValue });
  };

  const loginHandler = () => {
    setData({ ...data, isLoading: true });
    LoginAction({
      login_username: `+91${data.mobileNumber}`,
      method_of_login: "phone_otp",
      platform: "my_track",
    })
      .then((res) => {
        console.log("login response", res);

        fetchMobileNo(res?.user_data?.phone_number);

        const loginMethod = res?.allowed_method_of_login;

        if (loginMethod === "phone_otp") {
          OtpSentAction({
            login_username: `+91${data.mobileNumber}`,
            method_of_login: "phone_otp",
            purpose: "user_login",
          }).then(() => {
            setData((prev) => ({ ...prev, isLoading: false }));
            history.push(EKYC.OTP, {
              mobileView: data.mobileView,
              phone: res?.user_data?.phone_number,
            });
          });
        } else if (loginMethod === "phone_password") {
          setData((prev) => ({ ...prev, isLoading: false }));
          history.push(EKYC.PASSWORD_LOGIN, {
            mobileView: data.mobileView,
            phone: res?.user_data?.phone_number,
            username: res?.user_data?.username,
          });
        } else {
          setData((prev) => ({ ...prev, isLoading: false }));
          // alert("Login method not supported");
        }
      })
      .catch((err) => {
        console.log(`Loggin error > >> >${JSON.stringify(err)}`);
        const errorObj = {
          login_username: err?.non_field_errors?.[0],
        };
        setData({
          ...data,
          isLoading: false,
          isError: true,
          errorObj: errorObj,
        });
      });
  };

  const loginAction = (e) => {
    if (
      data?.mobileNumber == undefined ||
      data?.mobileNumber.trim().length == 0
    ) {
      const errorObj = {
        login_username: "Enter mobile number",
      };
      setData({ ...data, isLoading: false, isError: true, errorObj: errorObj });
      return;
    } else if (data?.mobileNumber.trim().length < 10) {
      const errorObj = {
        login_username: "Mobile number should be 10 digits.",
      };
      setData({ ...data, isLoading: false, isError: true, errorObj: errorObj });
      return;
    }

    if (data.isSessionClear) {
      triggerSimpleAjax(
        LOGOUT_ALL_SESSION,
        "POST",
        {},
        () => {
          // this.props.history.push(ROUTES.HOME_PAGE_URL);
          loginHandler();
        },
        () => {
          history.push(ROUTES.HOME_PAGE_URL);
        },
      );
      return true;
    }
    e && e.preventDefault();
    loginHandler();
  };

  const navigateToCouponLogin = (e) => {
    e && e.preventDefault();
    history.push(EKYC.COUPON_LOGIN);
  };

  return data.mobileView ? (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90%",
          maxWidth: "440px",
          padding: "2.5rem 1.5rem",
          marginTop: "-30px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
          zIndex: 2,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Welcome to eMyTrack 👋</h3>
        <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
          {EKYC_LOGIN_TITLE}
        </p>
        <FormStyle style={{ width: "100%" }}>
          <MobileTextBox
            labelName="Mobile No"
            name={"mobileNumber"}
            // check="ekycInput"
            value={data.mobileNumber}
            type="tel"
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.login_username}
          />
          <Button
            type="submit"
            onClick={loginAction}
            isLoading={data.isLoading}
            width="100%"
            bgColor="#4770C1"
            borderRadius="8px"
            fontStyle={{ fontSize: "14px", marginTop: "35px" }}
            boxHeight="38px"
          >
            {data.isSessionClear ? "Logout All Session" : "Login"}
          </Button>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <span
              onClick={navigateToCouponLogin}
              style={{
                marginTop: "35px",
                fontSize: "15px",
                color: "#4770C1",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Register using Coupon Code
            </span>
          </div>
        </FormStyle>
      </div>

      <div style={{ alignItems: "center", marginTop: "20px", width: "90%", maxWidth: "440px" }}>
        <FooterMobile textStyle="small" showSecuritySection={true} />
      </div>
    </>
  ) : (
    <form className="login-Form" onSubmit={loginAction}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Welcome to eMyTrack 👋
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        {EKYC_LOGIN_TITLE}
      </p>

      <CommonInput
        type="text"
        inputMode="numeric"
        label="Mobile No"
        name="mobileNumber"
        value={data.mobileNumber}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.login_username : ""}
        autoFocus
      />

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          {data.isSessionClear ? "Logout All Session" : "Login"}
        </button>
        <span
          onClick={navigateToCouponLogin}
          style={{
            fontSize: "16px",
            color: "#4770C1",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "500",
            fontFamily: "barlow",
          }}
        >
          Register using Coupon Code
        </span>
      </div>
    </form>
  );
};

export default EkycLogin;
